/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaskPersonResponse } from './TaskPersonResponse';
import {
    TaskPersonResponseFromJSON,
    TaskPersonResponseFromJSONTyped,
    TaskPersonResponseToJSON,
    TaskPersonResponseToJSONTyped,
} from './TaskPersonResponse';

/**
 * 
 * @export
 * @interface TaskNoteResponse
 */
export interface TaskNoteResponse {
    /**
     * 
     * @type {string}
     * @memberof TaskNoteResponse
     */
    taskNoteId?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskNoteResponse
     */
    noteContent?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskNoteResponse
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskNoteResponse
     */
    updated?: string;
    /**
     * 
     * @type {TaskPersonResponse}
     * @memberof TaskNoteResponse
     */
    appUserNoteCreator?: TaskPersonResponse;
    /**
     * 
     * @type {Array<TaskPersonResponse>}
     * @memberof TaskNoteResponse
     */
    taskNoteAppUsers?: Array<TaskPersonResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof TaskNoteResponse
     */
    read?: boolean;
}

/**
 * Check if a given object implements the TaskNoteResponse interface.
 */
export function instanceOfTaskNoteResponse(value: object): value is TaskNoteResponse {
    return true;
}

export function TaskNoteResponseFromJSON(json: any): TaskNoteResponse {
    return TaskNoteResponseFromJSONTyped(json, false);
}

export function TaskNoteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskNoteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'taskNoteId': json['taskNoteId'] == null ? undefined : json['taskNoteId'],
        'noteContent': json['noteContent'] == null ? undefined : json['noteContent'],
        'created': json['created'] == null ? undefined : json['created'],
        'updated': json['updated'] == null ? undefined : json['updated'],
        'appUserNoteCreator': json['appUserNoteCreator'] == null ? undefined : TaskPersonResponseFromJSON(json['appUserNoteCreator']),
        'taskNoteAppUsers': json['taskNote_AppUsers'] == null ? undefined : ((json['taskNote_AppUsers'] as Array<any>).map(TaskPersonResponseFromJSON)),
        'read': json['read'] == null ? undefined : json['read'],
    };
}

export function TaskNoteResponseToJSON(json: any): TaskNoteResponse {
    return TaskNoteResponseToJSONTyped(json, false);
}

export function TaskNoteResponseToJSONTyped(value?: TaskNoteResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'taskNoteId': value['taskNoteId'],
        'noteContent': value['noteContent'],
        'created': value['created'],
        'updated': value['updated'],
        'appUserNoteCreator': TaskPersonResponseToJSON(value['appUserNoteCreator']),
        'taskNote_AppUsers': value['taskNoteAppUsers'] == null ? undefined : ((value['taskNoteAppUsers'] as Array<any>).map(TaskPersonResponseToJSON)),
        'read': value['read'],
    };
}

